import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getTableFilters } from "../../ducks/table/selectors";
import { updateTableFilters } from "../../ducks/table/table";

import { TableFilterState, TableFilterValue } from "../../modules/Table/types";

export const useTableFilters = (): [
  Record<string, TableFilterState>,
  {
    setTableFilters: (filters: Record<string, TableFilterState>) => void;
    updateFiltersByLayer: (layerName: string, value: Record<string, TableFilterValue>) => void;
  },
] => {
  const dispatch = useDispatch();
  const tableFilters = useSelector(getTableFilters);

  const setTableFilters = useCallback(
    (filters: Record<string, TableFilterState>) => {
      dispatch(updateTableFilters(filters));
    },
    [dispatch],
  );

  const updateFiltersByLayer = useCallback(
    (layerName: string, value: Record<string, TableFilterValue>) => {
      dispatch(
        updateTableFilters({
          ...tableFilters,
          [layerName]: {
            ...tableFilters?.[layerName],
            ...value,
          },
        }),
      );
    },
    [dispatch, tableFilters],
  );

  return useMemo(
    () => [tableFilters, { setTableFilters, updateFiltersByLayer }],
    [tableFilters, setTableFilters, updateFiltersByLayer],
  );
};
